// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__lhgT6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1rt41"};